import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { CommonModule } from '@angular/common';

@Component({
	selector: 'kwo-payment-notification-dialog',
	templateUrl: './payment-notification-dialog.component.html',
	styleUrls: ['./payment-notification-dialog.component.scss'],
	host: { 'class': '' },
	standalone: true,
	imports: [CommonModule, FaIconComponent, MatDialogModule],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaymentNotificationDialogComponent implements OnInit {

	constructor(public dialogRef: MatDialogRef<PaymentNotificationDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: { payment_uri: string },
		private router: Router) { }

	ngOnInit(): void {

	}

	goMembership() {

		sessionStorage.setItem('kwo-payment', 'false');

		if (this.data.payment_uri) {

			window.location.href = this.data.payment_uri;
		} else {

			this.router.navigate(['/account/membership']);
		}
	}
}